<template>
  <div>
    <div class="sga-page-5 page-5">
      <h3>Certifications</h3>
      <p>
        Please take a moment to build your skills profile by adding any
        certifications or licenses you hold.
        <strong
          ><i>(Not applicable for those without formal education)</i></strong
        >
      </p>
      <p>
        Don't see the certification you're looking for?
        <span
          @click="submitNewCertification()"
          style="color: #00c8dc; text-decoration: underline; cursor: pointer"
          >Click here</span
        >
      </p>
      <el-form @submit.native.prevent>
        <el-form-item id="certificationdetails">
          <div
            id=""
            v-for="(certificationdetails,
            index) in sgaCertifications.userCertifications"
            :key="index"
          >
            <p>
              <i
                class="el-icon-remove delete_bachelorsdegreedetails"
                style="color: #dc3c3c; font-size: 20px"
                @click="removeCertificate(index)"
              ></i>
              &nbsp;&nbsp;&nbsp;&nbsp;Please select certification from the list
              below
            </p>
            <el-select
              v-model="selectedCodeDetail[index]"
              placeholder="Please select a category"
              filterable
              @change="selectCertificate(index)"
            >
              <el-option
                style="width: 780px"
                v-for="item in certlist"
                :title="item.description"
                :key="item.Id"
                :label="item.description"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-form-item
              :error="
                retrieveFieldError(
                  modelState,
                  'sgaCertifications.userCertifications[' +
                    index +
                    '].codeDeTailId'
                )
              "
            >
            </el-form-item>
            <el-form-item
              style="margin-bottom: 20px !important"
              :error="certificationdetails.selectedCertCodeDetailId_Error"
            >
            </el-form-item>
            <br />
            <el-row>
              <el-col :xl="12" :lg="12">                
                <el-row>
                  <p>Enter the date certification was acquired</p>
                  <el-date-picker
                    v-model="certificationdetails.acquiredDt"
                    type="date"
                    placeholder="Pick a date"
                    :picker-options="{disabledDate: disabledFutureDates}"   
                  >
                  </el-date-picker>                
                </el-row>
                <el-form-item
                  style="margin-bottom: 20px !important"
                  :error="certificationdetails.selectedCertAcquiredDate_Error"
                >
                </el-form-item>
              </el-col>
              <el-col :xl="11" :lg="11" class="mobile-spacer">
                <el-row>
                  <p>Enter the date certification expires</p>
                  <el-checkbox
                    v-model="certificationdetails.noExpiration"
                    @change="certificationdetails.expirationDt = null"
                    style="padding-right: 15px"
                    ><p>No Expiration</p></el-checkbox
                  >
                  <el-date-picker
                    :disabled="certificationdetails.noExpiration"
                    v-model="certificationdetails.expirationDt"
                    type="date"
                    placeholder="Pick a date"
                  >
                  </el-date-picker>
                </el-row>
                <el-form-item
                  style="margin-bottom: 20px !important"
                  :error="certificationdetails.selectedCertExpirationDate_Error"
                >
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              style="margin-bottom: 20px !important"
              :error="
                retrieveFieldError(
                  modelState,
                  'sgaCertifications.userCertifications[' +
                    index +
                    '].expirationDt'
                )
              "
            >
            </el-form-item>
            <el-form-item>
              <el-row>
                <el-col :xl="24">
                  <label role="text"
                    >Please upload image of your certification in the drop box below</label
                  >
                  <div class="ts-upload flexed" @click="setIndex(index)">
                    <el-upload
                      ref="upload"
                      class="upload-small"
                      drag
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :file-list="fileList"
                      :on-change="uploadImage"
                      :show-file-list="false"
                      :auto-upload="false"
                    >
                      <i class="el-icon-camera"></i>
                      <div class="el-upload__text">
                        Drop file here or <em>click to upload</em>
                      </div>
                    </el-upload>

                    <div class="card-container-sga" style="margin-top: -40px">
                      <span v-if="certificationdetails.image === null">
                        <img
                          src="~../../../../assets/img/crop_original-white-24dp.svg"
                          class="card-img-sga cert-placeholder"
                          style="width: 100%"
                        />
                      </span>
                      <span v-if="certificationdetails.image !== null">
                        <img
                          :src="
                            certificationdetails.image.s3Url
                              ? certificationdetails.image.s3Url
                              : certificationdetails.image
                          "
                          class="card-img-sga"
                          style="width: 100%"
                        />
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <el-row>
              <el-alert
                v-if="exceeded"
                :title="uploadErr"
                type="error"
                :closable="false"
                show-icon
              >
              </el-alert>
            </el-row>
            <hr class="ts-form-break" />
          </div>
          <div class="reminder reminder--blue">
            <div class="reminder-icon">
              <i class="fas fa-exclamation"></i>
            </div>
            <div class="reminder-copy">
              <p>
                <strong
                  >An image of your certification may not be required, but it is
                  important that you try and update your certifications with
                  images of the physical certificate as evidence in case your
                  employer asks</strong
                >
              </p>
            </div>
          </div>
          <button class="ts-btn ts-btn-white" @click.prevent="addCertification">
            + Add Another Certification
          </button>
          <br />
          <button
            class="ts-btn ts-btn-rounded ts-btn-secondary"
            @click="storeSection()"
          >
            Continue
          </button>
          <a class="back-link" href="/sga/questionnaire/4">
            <i class="fas fa-chevron-left"></i>Back
          </a>
        </el-form-item>
      </el-form>
    </div>
    <SubmitCertification
      :showModal="showSubmitCertModal"
      @close-modal="closeSubmitCertModal"
    ></SubmitCertification>
    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      :page12="page12"
      currentPage="page5"
    >
    </questionnaire-print>
    <!-- <JobSeekerCV ref="cv" :Image="Base64Raw" :Data="currentSga" :UserInfo="currentUser" :ShowProfile="showProfile"></JobSeekerCV>  -->
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    ></JobSeekerCV>
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="displayResume"
    ></ResumeListSelection>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>
<script>
import $ from "jquery";
import SubmitCertification from "../../../../components/SubmitCertification";
import JobSeekerCV from "../../components/JobSeekerCV";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import { BucketType } from "@/enums";
import { v4 as uuidv4 } from "uuid";
import { dataURItoBlob } from "@/utils";

export default {
  components: {
    SubmitCertification,
    JobSeekerCV,
    TSLoading,
    ResumeListSelection,
    QuestionnairePrint
  },
  created() {
    this.$store.dispatch("sga/getsga").then(res => {
      if (this.currentSga.sgaEmployeeInfo != null) {
        this.sgaEmployeeInfo = this.currentSga.sgaEmployeeInfo;
      }

      if (this.currentSga.sgaCertifications !== null) {
        this.sgaCertifications = Object.assign(
          this.sgaCertifications,
          res.sgaCertifications
        );
        this.$store
          .dispatch(
            "organisation/getAllReferencesByReferenceTypeCategory",
            "Certificate"
          )
          .then(list => {
            this.certlist = list;
          });

        this.sgaCertifications.userCertifications.forEach(
          async (element, index) => {
            this.selectedCodeDetail[index] = element.codeDeTailId;
            if (element.acquiredDt == "0001-01-01T00:00:00Z") {
              element.acquiredDt = null;
            }
            if (element.expirationDt == "0001-01-01T00:00:00Z") {
              element.expirationDt = null;
            }
            if (element.image === undefined) {
              element.image = null;
            } else {
              element.image = await this.getS3CertificateFile(element.image);
            }
          }
        );
      } else {
        this.sgaCertifications.userCertifications.push({
          description: null,
          acquiredDt: null,
          expirationDt: null,
          CertificationList: null,
          image: null,
          codeHeaderId: null,
          codeDeTailId: null
        });
        // TODO: not yet integrated API
        // this.certlist = [];
        // this.$store.dispatch('sga/getcodedetail').then((list) => {
        //   this.certlist = list.filter(r => r.codeHeaderId != "9c2f4cca-38a4-11eb-9a00-8c04ba629523");;
        // });
        this.$store
          .dispatch(
            "organisation/getAllReferencesByReferenceTypeCategory",
            "Certificate"
          )
          .then(list => {
            this.certlist = list;
          });
      }
      $("div[role=alert]").hide();
    });
    if (sessionStorage.getItem("profilephoto")) {
      this.base64Raw = sessionStorage.getItem("profilephoto");
    }
  },
  mounted() {
    this.$router.app.$on("questionnaire-print", this.printPage);
    // this.$router.app.$on('cv-print', this.printPageAsCV);
    this.$router.app.$on("show-resume-list", this.showResumeList);
  },
  destroyed() {
    if (
      this.$route.matched.find(c => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  data() {
    return {
      showResumeListModal: false,
      selectedCodeDetail: [],
      certificationList: [],
      showSubmitCertModal: false,
      loopindex: 0,
      fileList: [],
      isLoading: false,
      hasError: false,
      modelState: {},
      sgaEmployeeInfo: {},
      sgaYourJob: {
        jobRole: {},
        jobDescriptionTasks: [],
        customTasks: []
      },
      sgaEducation: {
        secondLevelEducation: {
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: []
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          bachelorsDegreeDetails: []
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: []
        },
        sectorExperience: {
          experience: false,
          experienceDetails: []
        },
        naicsLevel1Options: {}
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaTechnologies: {
        selectedTechnologies: [],
        customTechnologies: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        commuteDistance: "",
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      certCategory: {},
      certlist: [],
      uploadedCount: null,
      selectedIndex: null,
      uploadErr: null,
      exceeded: false,
      cvCollection: [],
      showProfile: true,
      base64Raw: null,
      certificationdetails: {
        NoExpiration: false
      },
      profile: {},
      profileSettings: []
    };
  },
  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    page1() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
        : {};
    },
    page2() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2;
        } else {
          return {
            sgaYourJob: this.sgaYourJob,
            taskSearch: this.taskSearch,
            hiddenTasks: this.hiddenTasks
          };
        }
      } else {
        return {
          sgaYourJob: this.sgaYourJob,
          taskSearch: this.taskSearch,
          hiddenTasks: this.hiddenTasks
        };
      }
    },
    page3() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3;
        } else {
          return { sgaEducation: this.sgaEducation };
        }
      } else {
        return { sgaEducation: this.sgaEducation };
      }
    },
    page4() {
      this.sgaWorkHistory.userWorkHistory.forEach(element => {
        if (element.workedFrom == "0001-01-01T00:00:00") {
          element.workedFrom = null;
        }
        if (element.workedTo == "0001-01-01T00:00:00") {
          element.workedTo = null;
        }
      });

      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4;
        } else {
          return { sgaWorkHistory: this.sgaWorkHistory };
        }
      } else {
        return { sgaWorkHistory: this.sgaWorkHistory };
      }
    },
    page5() {
      this.sgaCertifications.userCertifications.forEach(element => {
        if (element.acquiredDt == "0001-01-01T00:00:00") {
          element.acquiredDt = null;
        }
        if (element.expirationDt == "0001-01-01T00:00:00") {
          element.expirationDt = null;
        }
        if (element.image == undefined) {
          element.image = null;
        }
      });
      return {
        sgaCertifications: this.sgaCertifications,
        selectedCodeDetail: this.selectedCodeDetail
      };
    },
    page6() {
      return {
        sgaHiddenExtras: this.sgaHiddenExtras
      };
    },
    page7() {
      return {
        sgaKnowledge: this.sgaKnowledge
      };
    },
    page8() {
      return {
        sgaTechnologies: this.sgaTechnologies,
      };
    },
    page9() {
      return {
        sgaMindset: this.sgaMindset,
      };
    },
    page10() {
      return {
        sgaSkills: this.sgaSkills,
      };
    },
    page11() {
      return {
        sgaHiddenTalents: this.sgaHiddenTalents,
      };
    },
    page12() {
      return {
        sgaCulture: this.sgaCulture,
      };
    }
  },
  methods: {
    closeResumeListModal() {
      this.showResumeListModal = false;
    },
    showResumeList() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res.filter(d => d.isActive == true);
          this.loading = false;
          this.showResumeListModal = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    displayResume(setting) {
      var obj = {
        userid: this.currentUser.id,
        cvid: setting.id
      };
      this.$store
        .dispatch("account/getprofiledetails", obj)
        .then(res => {
          this.profile = res;
          this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
          this.closeResumeListModal();

          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        })
        .catch(res => {
          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        });
    },
    closeSubmitCertModal() {
      this.showSubmitCertModal = false;
    },
    submitNewCertification() {
      this.showSubmitCertModal = true;
    },
    addCertification() {
      this.sgaCertifications.userCertifications.push({
        description: null,
        acquiredDt: null,
        expirationDt: null,
        CertificationList: null,
        image: null,
        codeHeaderId: null,
        codeDeTailId: null
      });

      // TODO: not yet integrated API
      // this.$store.dispatch("sga/getcodedetail").then(list => {
      //   // this.certlist.push(list);
      //   this.certlist = list.filter(
      //     r => r.codeHeaderId != "9c2f4cca-38a4-11eb-9a00-8c04ba629523"
      //   );
      // });
      // TODO: new api
      // this.$store.dispatch(
      //   "organisation/getAllReferencesByReferenceTypeCategory",
      //   "Certificate"
      // );
    },
    async getS3CertificateFile(objectId) {
      const s3Url = await this.$store
        .dispatch("common/getImage", {
          objectId,
          BucketType: BucketType.UserCertifications
        })
        .then(res => {
          return res;
        });
      return { objectId, s3Url };
    },
    removeCertificate(index) {
      this.selectedCodeDetail.splice(index, 1);
      this.sgaCertifications.userCertifications.splice(index, 1);
    },
    setIndex(index) {
      this.selectedIndex = index;
    },
    selectCertificate(index) {
      const certDetails = this.certlist.find(
        (c) => c.id === this.selectedCodeDetail[index]
      );
      this.sgaCertifications.userCertifications[index].codeDeTailId =
        certDetails.id;

      this.sgaCertifications.userCertifications[index].codeDetailDesc =
        certDetails.description;
    },
    uploadImage(file) {
      if (file.raw.type == "image/png" || file.raw.type == "image/jpeg") {
        var fsize = file.size / 1024;
        if (fsize > 2000) {
          this.uploadErr =
            "File size should be at least 2000kb (2mb) or lower!";
          this.exceeded = true;
        } else {
          this.getBase64(file.raw).then(res => {
            this.sgaCertifications.userCertifications[
              this.selectedIndex
            ].image = res;
          });
        }
      } else {
        this.uploadErr = "Image should be in PNG or JPG format!";
        this.exceeded = true;
      }
    },
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    async storeSection() {
      this.isLoading = true;

      if (this.sgaCertifications) {
        this.sgaCertifications.userCertifications.forEach(
          (element) => {
            if (element.codeDeTailId === null) {
              element.selectedCertCodeDetailId_Error =
                "Please select certification name.";
            } else {
              element.selectedCertCodeDetailId_Error = null;
            }

            if (element.acquiredDt === null) {
              element.selectedCertAcquiredDate_Error =
                "Please select the date the certification was acquired.";
            } else if (new Date(element.acquiredDt) > new Date()) {
              element.selectedCertAcquiredDate_Error = "Acquired date must not be a future date."
            } else {
              element.selectedCertAcquiredDate_Error = null;
            }

            if (
              (element.noExpiration === undefined ||
                element.noExpiration === false) &&
              element.expirationDt === null
            ) {
              element.selectedCertExpirationDate_Error =
                "Please select the date the certification will expire.";
            } else if (
              element.acquiredDt !== null &&
              element.expirationDt !== null &&
              element.expirationDt <= element.acquiredDt
            ) {
              element.selectedCertExpirationDate_Error =
                "Expiration date cannot be on or before the date certification was acquired.";
            } else {
              element.selectedCertExpirationDate_Error = null;
            }
          }
        );

        let hasError = null;
        this.sgaCertifications.userCertifications.forEach(
          (element) => {
            if (
              element.selectedCertCodeDetailId_Error != null ||
              element.selectedCertAcquiredDate_Error != null ||
              element.selectedCertExpirationDate_Error != null
            ) {
              hasError = true;
              return false;
            }
          }
        );

        if (hasError) {
          this.isLoading = false;
          return false;
        }
      }

      this.currentSga.sgaCertifications = this.sgaCertifications;
      const certs = await this.uploadCertificateToS3(
        JSON.parse(JSON.stringify(this.sgaCertifications.userCertifications))
      );
      this.currentSga.sgaCertifications.userCertifications = certs[0];
      if (this.currentSga.sgaCertifications.id == null) {
        this.$store
          .dispatch("sga/postsga", this.currentSga)
          .then(() => {
            this.$router.app.$emit("navigateToNextStep");
          })
          .catch(res => {
            this.modelState = res.errors;
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("sga/putsga", this.currentSga)
          .then(() => {
            this.$router.app.$emit("navigateToNextStep");
          })
          .catch(res => {
            this.modelState = res.errors;
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }

      sessionStorage.setItem(
        "sgaDataForPrinting",
        JSON.stringify({
          page1: this.page1,
          page2: this.page2,
          page3: this.page3,
          page4: this.page4,
          page5: {
            sgaCertifications: this.currentSga.sgaCertifications,
            selectedCodeDetail: this.selectedCodeDetail
          }
        })
      );

      sessionStorage.setItem(
        "sgaDataForPrinting",
        JSON.stringify({
          page1: this.page1,
          page2: this.page2,
          page3: this.page3,
          page4: this.page4,
          page5: {
            sgaCertifications: this.currentSga.sgaCertifications,
            selectedCodeDetail: this.selectedCodeDetail
          }
        })
      );
    },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch("sga/getsga").then(data => {
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaEducation = data.sgaEducation || this.sgaEducation;
        this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
        this.sgaCertifications = this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;

        this.$store
          .dispatch("sga/getSGAforPrint", this.sgaHiddenExtras)
          .then(() => {
            this.$refs.cv.hideCV();
            this.$refs.questionnaire.showQuestionnaire();
            action();
            this.$refs.questionnaire.hideQuestionnaire();
          });
      });
    },
    async uploadCertificateToS3(certificates) {
      return await Promise.all(
        certificates.map(async (obj, index) => {
          if (obj.codeDeTailId !== null) {
            if (obj.image === null) return certificates;
            if (obj.image.objectId !== undefined) {
              certificates[index].image = certificates[index].image.objectId;
              return certificates;
            }
            const imageId = uuidv4();
            const file = await dataURItoBlob(obj.image);

            return this.$store
              .dispatch("common/uploadImage", {
                file,
                objectId: imageId,
                bucketType: BucketType.UserCertifications,
                fileExtension: "png"
              })
              .then(() => {
                certificates[index].image = imageId;
                return certificates;
              });
          }
        })
      );
    },
    isBase64(fileString) {
      return fileString.split(",").length > 1;
    },
    printPageAsCV(action) {
      this.cvCollection = [
        {
          userInfo: this.currentUser,
          image: this.base64Raw,
          survey: this.currentSga
        }
      ];
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
        });
    },
    disabledFutureDates(date) {
      return date.getTime() > Date.now();
    }
  }
};
</script>

<style lang="scss" scoped>
.cert-placeholder {
  height: 100%;
  width: 100%;
  background-color: #b8ccdf;
  color: white;
}
.reminder {
  -webkit-box-shadow: 0 0.15rem 0.15rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.15rem 0.15rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 40px;
  display: table;
  background-color: #cce5ff;
  .reminder-icon {
    padding: 5px 15px;
    border-radius: 0.5rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    display: table-cell;
    font-size: 20px;
    border-right: 0;
    background: #eef6ff;
    border: 2px solid #eef6ff;
    i {
      vertical-align: middle;
    }
  }
  .reminder-copy {
    padding: 8px;
    font-size: 14px;
    padding-left: 1rem;
    display: inline-block;
    color: #004085;
  }
}

@media screen and (max-width: 759px) {
  .mobile-spacer {
    margin-top: 30px !important;
  }

  .mobile-spacer p {
    margin-bottom: 0px !important;
  }
}
</style>
